import {getCurrentUsers} from "../workflow/workflow";
import _ from "lodash";

const moduleIdByStatus = {
    formX: 'm-I-bp1',
    buildOffer: 'm-I-bp2',
    submitOffer: 'm-I-bp4',
    realisation: 'm-I-bp5 bis'
}
export async function getEdfinWorkflowNotificationData(groupId) {

    const ongoingBusinessProjects = await global.app.I.BusinessProject.collection.aggregate([
        {
            $match: {
                'workflow.type': 'inProgress',
                group: new global.ObjectID(groupId)
            }
        },
        {
            $project:{
                "country": 1,
                "typeOfOffer": 1,
                "estimatedTurnover": 1,
                "workflow.step": 1,
                "workflow.order": 1,
            }
        }

    ]).toArray();

    const userProjectCombinations = await Promise.all(
        ongoingBusinessProjects.map(businessProject => (async () => {
            const reconstructedProject = {
                id: businessProject._id.toString(),
                country: {id: businessProject.country.toString()},
                typeOfOffer: {id: businessProject.typeOfOffer.toString()},
                estimatedTurnover: businessProject.estimatedTurnover,
                workflow: {...businessProject.workflow}
            }
            const currentBPUsers = await getCurrentUsers(reconstructedProject, {group: {id: groupId}})
            return currentBPUsers.map(teamMember => ({user: teamMember.user, businessProject}))
        })())
    )


    const groupedByUser = _.groupBy(_.flatten(userProjectCombinations), 'user.id')

    return Object.keys(groupedByUser).reduce((acc, userId) => {
        const groupedByStatus = _.groupBy(groupedByUser[userId], 'businessProject.workflow.step')
        return {
            [userId]: Object.keys(groupedByStatus).reduce((acc, status) => ({
                [moduleIdByStatus[status]]: groupedByStatus[status].length,
                ...acc
            }), {}),
            ...acc

        }
    }, {})
}
